import { Stack } from "@fluentui/react";
import { useEffect, useState } from "react";

import { TranslatedSignatureType } from "@/modules/Contracts/enums";
import { DocumentsCard } from "@/modules/Terms/components/DocumentsCard";
import { ShowInfoCard } from "@/modules/Terms/components/ShowInfoCard";
import { SignaturesCard } from "@/modules/Terms/components/SignaturesCard";
import { ITerm } from "@/modules/Terms/interfaces/ITerm.interface";
import { validateFieldData } from "@/modules/Terms/utils/validateFieldDate";
import { cpfCnpjFormatter } from "@/utils/FormatCPForCNPJ";
import { formatDateAndTimeToString } from "@/utils/FormatDate";
import { phoneNumberFormatter } from "@/utils/PhoneNumberFormatter";

interface DisplayComplementaryDocumentsProps {
  term: ITerm;
  refetchTerm: () => Promise<void>;
}
export const DisplayComplementaryDocumentInfo = ({
  term,
  refetchTerm
}: DisplayComplementaryDocumentsProps) => {
  const [assignorData, setAssignorData] = useState({});
  const [termData, setTermData] = useState({});

  useEffect(() => {
    setAssignorData({
      "Nome:": term?.termDataDraft?.fullName,
      "Documento:": cpfCnpjFormatter(term?.termDataDraft?.documentNumber),
      "Email:": term?.termDataDraft?.email,
      "WhatsApp:": phoneNumberFormatter(term?.termDataDraft?.whatsapp),
      "Endereço:": [
        {
          title: "",
          value: validateFieldData(
            "string",
            `${term?.termDataDraft?.street}, ${term?.termDataDraft?.number ?? ""}`
          )
        },
        {
          title: "",
          value: validateFieldData("string", term?.termDataDraft?.neighborhood)
        },
        {
          title: "",
          value: validateFieldData(
            "string",
            `${term?.termDataDraft?.city} - ${term?.termDataDraft?.uf}`
          )
        },
        {
          title: "",
          value: validateFieldData("string", term?.termDataDraft?.zipCode)
        }
      ]
    });

    setTermData({
      "Tipo de Assinatura:": TranslatedSignatureType[term?.signature?.type],
      "Autor do termo:": term?.user?.fullName,
      "Criado em:": formatDateAndTimeToString(term?.createdAt),
      "Atualizado em:": formatDateAndTimeToString(term?.updatedAt)
    });
  }, [term]);

  return (
    <>
      <Stack>
        <div style={{ marginTop: 20 }}>
          <Stack horizontal wrap tokens={{ childrenGap: 15 }}>
            <Stack.Item className="ms-sm12 ms-xl5" grow>
              <ShowInfoCard
                info={assignorData}
                title={"Cedente"}
                iconName={"Contact"}
              />
            </Stack.Item>

            <Stack.Item className="ms-sm12 ms-xl5" grow>
              <ShowInfoCard
                info={termData}
                title={"Dados Base"}
                iconName={"ClipboardList"}
              />
            </Stack.Item>
          </Stack>
        </div>
      </Stack>

      <Stack horizontal wrap tokens={{ childrenGap: 15 }}>
        <Stack.Item className="ms-sm12 ms-xl5" grow>
          <SignaturesCard
            documentId={term.id}
            eletronicSignature={term?.externalElectronicSignatureData}
            businessUnitId={term.businessUnitId}
            refetchData={refetchTerm}
            termDataDraft={term?.termDataDraft}
            canUpdateSignatureMethod={true}
          />
        </Stack.Item>

        <Stack.Item className="ms-sm12 ms-xl5" grow>
          <DocumentsCard uploads={[]} canUpload={false} />
        </Stack.Item>
      </Stack>
    </>
  );
};
